import { GenericError } from '../errors';
/**
 * Converts errors to a json api error response
 */
export function convertApiErrorResponseToJson(error, debug) {
    return error.convertToJSON(debug);
}
/**
 * Converts errors to a stringified json api error response
 */
export function convertApiErrorResponseToString(error, debug) {
    return JSON.stringify(convertApiErrorResponseToJson(error, debug));
}
/**
 * Is this a json api error response?
 */
export function isApiErrorResponse(data) {
    return (typeof data === 'object' &&
        data !== null &&
        GenericError.isSerializableError(data));
}
/**
 * Parse a json api error response and return a serializable error object
 */
export async function parseApiErrorResponse(res) {
    const json = await res.json();
    if (isApiErrorResponse(json)) {
        return json;
    }
    return undefined;
}
